module.exports = __webpack_public_path__ + "img/detail_D30A.fffd9b35.png";